import { any } from '@amcharts/amcharts5/.internal/core/util/Array';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { CharityDataShareServiceService } from '../../../components/charity/charities/services/charity-data-share-service.service';
import { ConfigurationService } from '../../../Configuration/configuration.service';
import { ADCreateUserModel } from '../../../Data/Models/ADCreateUserModel/adcreate-user-model';
import { BaseEntityModel } from '../../../Data/Models/Common/base-entity-model';
import { BaseSearchModel } from '../../../Data/Models/Common/base-search-model';
import { AgentsModel } from '../../../Data/Models/Users/agents-model';
import { RolesModel } from '../../../Data/Models/Users/roles-model';

@Injectable({
  providedIn: 'root'
})
export class UsermanagementService {

  baseURL: string;
  commonApi: string;
  financialPeriodId: number = 0;
  constructor(private http: HttpClient, private configService: ConfigurationService, private dataShareService: CharityDataShareServiceService, private router: Router) {
    this.baseURL = this.configService.getAPIBaseUrl();
    this.commonApi = this.configService.getCommonApi();

    this.dataShareService.CurrentAP_ID$.subscribe(data => {
       this.financialPeriodId = data ? +data : 0;
})
   

  }

  GetRolesDetails(UserId: number): Observable<BaseEntityModel<RolesModel>> {
    return this.http.get<BaseEntityModel<RolesModel>>(this.baseURL+'/RolesManagement/GetRolesDetails?UserId=' + UserId);
  }

  SaveRolesDetails(Data: RolesModel): Observable<BaseEntityModel<RolesModel>> {
    return this.http.post<BaseEntityModel<RolesModel>>(this.baseURL +'/RolesManagement/SaveRolesDetails', Data);
  }

  CreatePassword(Data: ADCreateUserModel): Observable<{ message: string }> {
    var url = `${this.baseURL}/AgentDetails/CreatePassword`
    return this.http.post<{ message: string }>(url, Data);
  }
  GetAllAgentDetails(CentralUserId: number): Observable<BaseEntityModel<AgentsModel>> {
    return this.http.get<BaseEntityModel<AgentsModel>>(this.baseURL + '/AgentDetails/GetAllAgentDetails?CentralUserId=' + CentralUserId);
  }

  SaveUserDetails(Data: AgentsModel): Observable<BaseEntityModel<AgentsModel>> {
    debugger
    var CharityConfig = Data.charityConfigurations.filter((x : any) => x.Checked == true);
    var Charites = '';
    for (let i = 0; i < CharityConfig.length; i++) {
      Charites = Charites == '' ? CharityConfig[i].charityID : Charites + '/' + CharityConfig[i].charityID;
    }
    Data.charityConfigurations = Charites == '' ? null : Charites?.toString();

    return this.http.post<BaseEntityModel<AgentsModel>>(this.baseURL +'/AgentDetails/SaveAgentDetails', Data);
  }

  ActiveInactiveUser(Data: AgentsModel): Observable<BaseEntityModel<AgentsModel>> {
    return this.http.post<BaseEntityModel<AgentsModel>>(this.baseURL + '/AgentDetails/ActiveInactiveUser', Data);
  }

  RemoveUser(Data: AgentsModel): Observable<BaseEntityModel<AgentsModel>> {
    return this.http.post<BaseEntityModel<AgentsModel>>(this.baseURL + '/AgentDetails/RemoveUser', Data);
  }


  GetCountriesData(): Observable<BaseEntityModel<any[]>> {
    return this.http.get<BaseEntityModel<any[]>>(this.baseURL + '/AgentDetails/GetCountriesList');
  }

  CheckLinkExpiredorUsed(Link: any): Observable<{ message: string }> {
    const url = `${this.baseURL}/AgentDetails/CheckLinkExpiredorUsed?link=${Link}`;
    return this.http.get<{ message: string }>(url);
  }

  GetUserRoleAccess2(UserId: any): Observable<BaseEntityModel<RolesModel>> {
    return this.http.get<BaseEntityModel<RolesModel>>(this.baseURL + '/RolesManagement/GetUserRoleAccess?UserId=' + UserId);
  }
  GetUserRoleAccess(UserId: number): Observable<BaseEntityModel<RolesModel>> {
    return this.http.get<BaseEntityModel<RolesModel>>(
      `${this.baseURL}/RolesManagement/GetUserRoleAccess`,
      {
        params: {
          UserId: UserId,
          FinacialperiodId: this.financialPeriodId
        }
      }
    );
  }


  GetUserLastLogintime(UserId: any): Observable<BaseEntityModel<AgentsModel>> {
    return this.http.get<BaseEntityModel<AgentsModel>>(this.baseURL + '/AgentDetails/UserLastLogintime?UserId=' + UserId);
  }

  ForgotPassword(Email: string): Observable<string> {
    const url = `${this.baseURL}/AgentDetails/ForgotPassword?Email=${encodeURIComponent(Email)}`;
    return this.http.get(url, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/plain'
      }),
      responseType: 'text' as const
    });
  }
  GetSubmissionCredentials(PeriodID: any, UserId: any, CentralUserId: any, CharityId: any): Observable<any> {
    debugger
    const url = this.baseURL + '/SubmissionCredentials/GetSubmissionCredentials?PeriodID=' + +PeriodID + '&UserId=' + +UserId + '&CentralUser=' + +CentralUserId + '&charityId=' + +CharityId;
    return this.http.get(url);
  }
  UnfreezeAP(FinancialPeriodsID: any): Observable<any> {
    const url = `${this.baseURL}/FinalAccounts/UnfreezeAP?FinancialPeriodsID=${FinancialPeriodsID}`;

    return this.http.get(url).pipe(
      tap((response: any) => {
      
        localStorage.setItem('account_Type', response.mesage);
      }),
      map(response => {
      
        return response;
      }),
      catchError(error => {
        console.error('Error in service:', error);
        // you can transform or rethrow
        return throwError(() => error);
      })
    );
  }
  GoToSubmissions() {
    this.router.navigate(['/submissions'])
  }
}
